import { Injectable } from '@tanbo/vue-di-plugin'

import { ParamsClean } from '@/common/decorators/params-clean'
import { Http } from '@/services/http'

export interface RequestParams {
  /** 页码（最小页码：1） */
  page: number
  /** 每页数量 */
  limit: number
  /** 设备id */
  peripheral_id: string
  /** 时间范围 1：全部 ，2：最近24小时 （默认），3：最近7天 ，4：近一个月 */
  time_range: number
}

export interface List {
  /** 计算机名 */
  computer_name: string
  /** 所属分组 */
  group_name: string
  /** 登记用户名 */
  user_mark: string
  /** 内网ip */
  client_ip: string
  /** 外网ip */
  system_ip: string
  /** 终端状态，1：在线，2：离线 */
  device_status: string
  /** 系统类型 1-windows 2-linux */
  system_type?: number
  /** 最后接入时间 */
  access_time: number
  /** 触发策略 */
  strategy_name?: string
}

export interface ResponseData {
  /** 设备信息列表 */
  list: List[]
  /** 总数 */
  total: number
}

@Injectable()
export class TerminalListService {
  constructor (private http: Http) {}

  @ParamsClean()
  getPeripheralcontrolViewPeripheralAccessedRecordsGet (data: RequestParams) {
    return this.http.post<ResponseData>('/peripheralcontrol/view/peripheral/accessed-records/get', data)
  }
}
